//问卷
export const SK_INQUIRY_LIST = 'sk_inquiry_list'
//问卷详情
export const SK_INQUIRY_DETAILS = 'sk_inquiry_details'
//问卷编辑
export const SK_INQUIRY_EDIT = 'sk_inquiry_edit'
